import { useState, useCallback, useEffect } from 'react';
import { getProfileApi } from '@/sidebar/infrastructure/adapters/partner';

export const useProfile = () => {
  const [profile, setProfile] = useState<any>();

  const fetchProfile = useCallback(async () => {
    setProfile(await getProfileApi());
  }, []);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  return profile;
};
